import { React } from 'react';
import './page-header.scss';

export const PageHeader = ({ title, text, img, link, subscription, ...props }) => {
  return (
    <div className={`page-header-component`}>
      <h3 className="page-header">{title}</h3>
      <div className="header-content">
        <div className="content-img">{img}</div>
        <div className={`content-text${subscription ? ' subscribe-form' : ''}`}>
          {text}
          {subscription ? <>{subscription}</> : null}
        </div>
      </div>
      {link ? <div className="header-link">{link}</div> : ''}
    </div>
  );
};

PageHeader.propTypes = {};
